import runtimeConfig from './config/runtimeConfig';

const statisticDefaults = {
    groupParams: [
        'Day',
        'Hour',
        'Week',
        'Month',
        'Quarter',
        'Year',
        'WeekDay',
        'DayHour',
        'Offer',
        'Goal',
        'Link',
        'UtmMedium',
        'UtmSource',
        'UtmCampaign',
        'UtmTerm',
        'UtmContent',
        'Param1',
        'Param2',
        'Param3',
        'Param4',
        'Country',
        'Rejected',
        'DeviceType',
        'DeviceOs',
        'RefererDomain',
        'RefererSignificantSubdomain',
        'RefererPath',
        'RefererPage',
        'CreativeType',
        'CreativeId',
    ],
    groupParamsSegment: [
        'Offer',
        'Goal',
        'Link',
        'UtmMedium',
        'UtmSource',
        'UtmCampaign',
        'UtmTerm',
        'UtmContent',
        'Param1',
        'Param2',
        'Param3',
        'Param4',
        'Country',
        'Rejected',
        'DeviceType',
        'DeviceOs',
        'CreativeType',
        'CreativeLinkId',
        'CreativeContainerId',
        'CreativeBannerId',
        'CreativeLandingId',
        'CreativePromoCodeId'
    ],
};

export const statistics = statisticDefaults;

export const statisticsByDay = {
    groupParams: [
        'Day',
        'Offer',
        'Goal'
    ],
    groupParamsSegment: [
        'Offer',
        'Goal'
    ],
};

export const statisticsByCountry = {
    groupParams: [
        'Day',
        'Offer',
        'Goal',
        'Country'
    ],
    groupParamsSegment: [
        'Offer',
        'Goal',
        'Country'
    ],
};

export const statisticsByUTM = {
    groupParams: [
        'Day',
        'Offer',
        'UtmMedium',
        'UtmSource',
        'UtmCampaign',
        'UtmTerm',
        'UtmContent',
    ],
    groupParamsSegment: [
        'Offer',
        'UtmMedium',
        'UtmSource',
        'UtmCampaign',
        'UtmTerm',
        'UtmContent',
    ],
};

export const statisticsByReactivation = {
    groupParams: [
        'Day',
        'Offer',
        'UnactivePeriod',
        'Param2',
        'UtmMedium',
        'UtmSource',
        'UtmCampaign',
        'UtmTerm',
        'UtmContent',
    ],
    groupParamsSegment: [
        'Offer',
        'ReactivationUnactivePeriod',
        'ReactivationParam2',
        'ReactivationUtmMedium',
        'ReactivationUtmSource',
        'ReactivationUtmCampaign',
        'ReactivationUtmTerm',
        'ReactivationUtmContent',
    ],
};

export const statisticsByCreative = {
    groupParams: [
        'Day',
        'UtmSource',
        'CreativeType',
        'CreativeId',
    ],
    groupParamsSegment: [
        'UtmSource',
        'CreativeType',
        'CreativeLinkId',
        'CreativeContainerId',
        'CreativeBannerId',
        'CreativeLandingId',
        'CreativePromoCodeId'
    ],
};

export const statisticsByReferer = {
    groupParams: [
        'Day',
        'UtmSource',
        'RefererDomain',
        'RefererSignificantSubdomain',
        'RefererPath',
        'RefererPage'
    ],
    groupParamsSegment: [
        'UtmSource'
    ],
};

export const statisticsByReferral = {
    groupParams: [
        'Referrer'
    ],
    groupParamsSegment: [
        'Referrer',
        'Referral',
        'Offer',
        'Advertiser',
    ],
};

export const timeInterval = [
    { value: 'Hour', key: 'hour' },
    { value: 'Day', key: 'day' },
    { value: 'Week', key: 'week' },
    { value: 'Month', key: 'month' },
];

export const postbackParamsHidden = [
    'commission_sale_sum',
    'commission_lead',
    'commission_sale',
    'commission_total',
    'commission_promotion_lead',
    'commission_promotion_sale',
    'commission_promotion_total'
];

export const statuses = {
    paused: 'paused',
    active: 'active',
};

export const mimeTypes = {
    'image/gif': 'Gif',
};

export const phoneCodesCountries = [
    { value: '7', code: 'RU' },
    { value: '77', code: 'KZ' },
    { value: '375', code: 'BY' },
    { value: '994', code: 'AZ' },
    { value: '374', code: 'AM' },
    { value: '44', code: 'GB' },
    { value: '84', code: 'VN' },
    { value: '9955', code: 'GE' },
    { value: '972', code: 'IL' },
    { value: '91', code: 'IN' },
    { value: '996', code: 'KG' },
    { value: '371', code: 'LV' },
    { value: '370', code: 'LT' },
    { value: '373', code: 'MD' },
    { value: '507', code: 'PA' },
    { value: '40', code: 'RO' },
    { value: '1', code: 'US' },
    { value: '992', code: 'TJ' },
    { value: '66', code: 'TH' },
    { value: '90', code: 'TR' },
    { value: '998', code: 'UZ' },
    { value: '380', code: 'UA' },
    { value: '372', code: 'EE' },
    { value: '82', code: 'KR' },
    { value: '81', code: 'JP' },
];

export const metaUtmParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
];

export const allowGeneratePromocodes = Boolean(runtimeConfig.allowGeneratePromocodes);

const config = {
    ...runtimeConfig,
    reportFileNameCSV: runtimeConfig.reportFileNameCSV || 'Report',
    reportByDayFileNameCSV: runtimeConfig.reportByDayFileNameCSV || 'ReportByDay',
    reportByCountryFileNameCSV: runtimeConfig.reportByCountryFileNameCSV || 'ReportByCountry',
    reportByRefererFileNameCSV: runtimeConfig.reportByRefererFileNameCSV || 'ReportByReferer',
    reportByCreativeFileNameCSV: runtimeConfig.reportByCreativeFileNameCSV || 'ReportByCreative',
    reportByUTMFileNameCSV: runtimeConfig.reportByUTMFileNameCSV || 'ReportByUTM',
    reportByReactivationFileNameCSV: runtimeConfig.reportByReactivationFileNameCSV || 'ReportByReactivation',
    reportByReferralFileNameCSV: runtimeConfig.reportByReferralFileNameCSV || 'ReportByReferral',
    reportDateFormat: runtimeConfig.reportDateFormat || 'YYYY-MM-DD',
    reportItemsCount: Number.isFinite(runtimeConfig.reportItemsCount) ? runtimeConfig.reportItemsCount : 1000,
    defaultGroupByForReferral: runtimeConfig.defaultGroupByForReferral || 'Referrer',
    defaultChartBar: runtimeConfig.defaultChartBar || 'bar',
    chartBar: runtimeConfig.chartBar || 'bar',
    chartLine: runtimeConfig.chartLine || 'line',
    XBT: runtimeConfig.XBT || '<span class="bitcoin">B</span>',
    chart: {
        minNumberPointsOnAxis: runtimeConfig.chart?.minNumberPointsOnAxis || 3,
        maxNumberPointsOnAxis: runtimeConfig.chart?.maxNumberPointsOnAxis || 370,
    },
};

export default config;
